function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUkFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "https://www.w3.org/2000/svg",
    xmlnsXlink: "https://www.w3.org/1999/xlink",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(60%,60%,60%)",
      fillOpacity: 1
    },
    d: "M 10 0 C 12.761719 0 15.261719 1.121094 17.070312 2.929688 C 18.878906 4.738281 20 7.238281 20 10 C 20 12.761719 18.878906 15.261719 17.070312 17.070312 C 15.261719 18.878906 12.761719 20 10 20 C 7.238281 20 4.738281 18.878906 2.929688 17.070312 C 1.121094 15.261719 0 12.761719 0 10 C 0 7.238281 1.121094 4.738281 2.929688 2.929688 C 4.738281 1.121094 7.238281 0 10 0 Z M 10 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 10 0.761719 C 12.550781 0.761719 14.863281 1.796875 16.53125 3.46875 L 16.574219 3.511719 C 18.222656 5.179688 19.238281 7.472656 19.238281 10 C 19.238281 12.550781 18.203125 14.863281 16.53125 16.53125 L 16.484375 16.574219 C 14.816406 18.222656 12.523438 19.238281 10 19.238281 C 7.453125 19.238281 5.140625 18.203125 3.46875 16.53125 C 1.796875 14.859375 0.761719 12.550781 0.761719 10 C 0.761719 7.449219 1.796875 5.136719 3.46875 3.46875 C 5.140625 1.796875 7.449219 0.761719 10 0.761719 Z M 10 0.761719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 10 1.546875 C 14.667969 1.546875 18.453125 5.332031 18.453125 10 C 18.453125 14.667969 14.667969 18.453125 10 18.453125 C 5.332031 18.453125 1.546875 14.667969 1.546875 10 C 1.546875 5.332031 5.332031 1.546875 10 1.546875 Z M 10 1.546875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.392157%,12.941176%,41.176471%)",
      fillOpacity: 1
    },
    d: "M 7.167969 7.015625 L 7.167969 2.03125 C 5.554688 2.609375 4.164062 3.660156 3.171875 5.015625 L 7.167969 7.011719 Z M 7.167969 12.988281 L 7.167969 17.96875 C 5.554688 17.394531 4.167969 16.34375 3.171875 14.984375 Z M 12.8125 12.988281 L 12.8125 17.972656 C 14.433594 17.402344 15.824219 16.351562 16.820312 14.992188 L 12.8125 12.984375 Z M 12.8125 7.015625 L 12.8125 2.027344 C 14.433594 2.597656 15.828125 3.648438 16.824219 5.007812 L 12.8125 7.011719 Z M 12.8125 7.015625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(78.431373%,6.27451%,18.039216%)",
      fillOpacity: 1
    },
    d: "M 17.511719 12.820312 L 15.632812 12.820312 L 17.558594 13.785156 C 17.683594 13.535156 17.796875 13.277344 17.898438 13.011719 Z M 17.148438 5.484375 L 13.769531 7.175781 L 15.652344 7.175781 L 17.5625 6.21875 C 17.4375 5.96875 17.296875 5.722656 17.148438 5.484375 Z M 8.296875 11.691406 L 8.296875 18.28125 C 8.847656 18.394531 9.417969 18.453125 10 18.453125 C 10.578125 18.453125 11.140625 18.394531 11.683594 18.285156 L 11.683594 11.691406 L 18.285156 11.691406 C 18.394531 11.144531 18.453125 10.578125 18.453125 10 C 18.453125 9.417969 18.394531 8.851562 18.28125 8.300781 L 11.683594 8.300781 L 11.683594 1.714844 C 11.128906 1.601562 10.566406 1.546875 10 1.546875 C 9.417969 1.546875 8.847656 1.605469 8.296875 1.71875 L 8.296875 8.300781 L 1.71875 8.300781 C 1.605469 8.859375 1.546875 9.429688 1.546875 10 C 1.546875 10.578125 1.605469 11.144531 1.714844 11.691406 Z M 2.464844 7.179688 L 4.34375 7.179688 L 2.433594 6.226562 C 2.308594 6.476562 2.195312 6.734375 2.097656 6.996094 Z M 6.210938 12.824219 L 4.332031 12.824219 L 2.433594 13.773438 C 2.5625 14.027344 2.699219 14.273438 2.851562 14.511719 L 6.226562 12.824219 Z M 6.210938 12.824219 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkFlag);
export default __webpack_public_path__ + "static/media/UKFlag.fa0e4f6cb2d9ee0a08071b1295cc04b5.svg";
export { ForwardRef as ReactComponent };